/**
 * External dependencies
 */
import styled, { css } from 'styled-components';
import { __ } from '@web-stories-wp/i18n';
import { Text } from '@web-stories-wp/design-system';

export const PaneBottom = styled.div`
  position: relative;
  height: 100%;
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  margin-top: 8px;
`;

export const DropDownContainer = styled.div`
  margin-top: 1px;
`;

export const TagLabel = styled(Text)`
  color: ${({ theme, isSubLabel }) =>
    isSubLabel ? theme.colors.fg.disable : theme.colors.fg.primary};
  text-align: ${({ isSubLabel }) => (isSubLabel ? 'left' : 'right')};

  ${({ isSubLabel }) =>
    isSubLabel &&
    css`
      white-space: nowrap;
    `}
`;

export const ChipContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  overflow-x: hidden;
`;

export const Chip = styled(Text)`
  color: ${({ theme }) => theme.colors.standard.white};
  padding: 2px 8px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.bg.secondary};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const SelectedTag = styled.div`
  color: ${({ theme }) => theme.colors.standard.white};
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.bg.tertiary};
  display: flex;
  align-items: center;
  padding-left: 8px;
  font-size: ${12 / 16}em;
  height: 24px;
  max-width: 100%;
`;

export const SelectedTagLabel = styled.span`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const SelectedTagClear = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  width: 24px;
  height: 24px;
  color: ${({ theme }) => theme.colors.fg.secondary};
  border-top-right-radius: inherit;
  border-bottom-right-radius: inherit;
  cursor: pointer;
  position: relative;
  pointer-events: auto;

  &:hover,
  &:focus-visible {
    background-color: ${({ theme }) => theme.colors.bg.quaternary};
  }

  svg {
    width: 32px;
    height: 32px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

export const dropdownStylesOverride = css`
  width: 100%;
  padding: 12px 16px 12px 24px;
  margin-top: 0px;

  ul {
    display: grid;
    grid-template-columns: min-content 1fr;
    column-gap: 2px;
  }

  li {
    overflow-x: hidden;
  }

  li[role='presentation'] {
    grid-column: 1 / 3;
    padding: 0;
    margin: 0 0 6px 0;
  }

  li[role='presentation'] span {
    font-weight: 700;
    color: ${({ theme }) => theme.colors.fg.primary};
    font-size: ${14 / 16}em;
  }

  li:not([role='presentation']) {
    display: grid;
    grid-column: 1 / 3;
    grid-template-columns: subgrid;
    grid-template-rows: subgrid;
    padding-block: 4px;
    cursor: pointer;
  }
`;
